import { FC } from 'react';
import { Icon } from '../Icon/Icon';

import './PerformantPrintable.scss';

type Props = {
	baseClass: string;
	isLoading: boolean;
};

export const PerformantPrintable: FC<Props> = ({
	baseClass,
	isLoading = false,
}) => {
	const handlePrint = () => {
		const printContextClass = `printing-context-${baseClass}`;

		document.body.classList.add(printContextClass);
		window.print();
		setTimeout(() => {
			document.body.classList.remove(printContextClass);
		}, 500);
	};

	return (
		<div className="PerformantPrintable">
			<Icon
				onClick={isLoading ? noop : handlePrint}
				name="Print"
				width={22}
				key="PrintIcon"
				className={isLoading ? 'Printable__PrintIcon--loading' : ''}
			/>
		</div>
	);
};

const noop = () => {};
